export const SCHOOL_LOADING_ERROR_CODES = {
    USER_PROFILE: {
        code: 'SCH-LD-001',
        description: 'Timed out waiting for the authenticated user profile.',
    },
    ACCOUNT_TYPE: {
        code: 'SCH-LD-002',
        description: 'Timed out resolving the user account type.',
    },
    ACTIVE_ORGANISATION: {
        code: 'SCH-LD-003',
        description: 'Timed out resolving the active school organisation.',
    },
    SCHOOL_TYPE_CHECK: {
        code: 'SCH-LD-004',
        description: 'Timed out validating the active organisation type.',
    },
    SCHOOL_ACCESS: {
        code: 'SCH-LD-005',
        description: 'Timed out loading school and school-user access data.',
    },
    BOOKINGS_ACCESS: {
        code: 'SCH-LD-006',
        description: 'Timed out validating access to school bookings.',
    },
    SCHOOL_HOME: {
        code: 'SCH-LD-007',
        description: 'Timed out loading the school home account state.',
    },
    DEFAULT_SCHOOL: {
        code: 'SCH-LD-008',
        description: 'Timed out redirecting to the default school.',
    },
    SCHOOL_WORKSPACE: {
        code: 'SCH-LD-009',
        description: 'Timed out loading the My School workspace.',
    },
    NOTIFICATION_SETTINGS: {
        code: 'SCH-LD-010',
        description: 'Timed out loading school-user notification settings.',
    },
    SCHOOL_POLICIES: {
        code: 'SCH-LD-011',
        description: 'Timed out loading school policies.',
    },
    MAPS_LIBRARY: {
        code: 'SCH-LD-012',
        description: 'Timed out loading the location maps library.',
    },
    SCHOOL_LAYOUT: {
        code: 'SCH-LD-013',
        description: 'Timed out loading at the SchoolLayout component..',
    },
} as const

export type SchoolLoadingErrorCode =
    (typeof SCHOOL_LOADING_ERROR_CODES)[keyof typeof SCHOOL_LOADING_ERROR_CODES]['code']

const SCHOOL_LOADING_ERROR_CODE_SET = new Set<string>(
    Object.values(SCHOOL_LOADING_ERROR_CODES).map(({ code }) => code)
)

export const isSchoolLoadingErrorCode = (
    value: string | null
): value is SchoolLoadingErrorCode =>
    value !== null && SCHOOL_LOADING_ERROR_CODE_SET.has(value)
